import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DossierType/All', method: 'GET', body: null, token: token })
}
